
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt, FaBarcode } from 'react-icons/fa'
import { FaMoneyBillWave } from 'react-icons/fa6'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import './ListSimpleProductRow.css'

import EditSimpleProduct from '../EditSimpleProduct'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListSimpleProductRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess, handleOnSelected, itemData, enableSelectRow }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditSimpleProduct, setModalEditSimpleProduct] = useState(false)
    const [simpleProductId, setSimpleProductId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [simpleProductName, setSimpleProductName] = useState("")

    /* Selected item */
    const [selectedItem, setSelectedItem] = useState(itemData || {})

    const handleSelected = (item) => {
        if (enableSelectRow) {
            setSelectedItem(item)
            handleOnSelected(item)
        }
    }

    async function deleteSimpleProduct(id) {
        let msgType = 'success'
        const data = await api.delete(`/simpleProduct/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div
                    key={item._id}
                    className={`pg-item ${enableSelectRow ? 'pg-item-selectable' : ''} ${enableSelectRow && selectedItem._id === item._id ? 'pg-item-selected' : ''}`}
                    onClick={() => handleSelected(item)}
                >
                    <div className='pg-item-main'>
                        <div className='sp-row-text'>
                            <span className='sp-row-name'>{item.description}</span>
                            <div className='sp-row-meta'>
                                <span className='sp-row-code'>#{item.code}</span>
                                {item.unit?.label && (
                                    <span className='sp-row-unit-badge'>{item.unit.label}</span>
                                )}
                            </div>
                            <div className='sp-row-links'>
                                {item.ncm && (
                                    <span className='sp-row-link-item'><FaBarcode size={11} />{item.ncm}</span>
                                )}
                                {item.totalInCash && (
                                    <span className='sp-row-price'><FaMoneyBillWave size={11} />R$ {item.totalInCash} à vista</span>
                                )}
                            </div>
                        </div>
                    </div>

                    {!enableSelectRow && (
                        <div className='shd-row-box-item-action'>
                            {myPermissionEdit &&
                                <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={(e) => { e.stopPropagation(); setSimpleProductId(item._id); setModalEditSimpleProduct(true) }} />
                            }
                            {myPermissionDelete &&
                                <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={(e) => { e.stopPropagation(); setModalDeleteItem(true); setSimpleProductId(item._id); setSimpleProductName(item.description) }} />
                            }
                        </div>
                    )}
                </div>
            ))
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditSimpleProduct}
                changeStatus={setModalEditSimpleProduct}
                w={96}
                content={
                    <EditSimpleProduct id={simpleProductId} handleOnSuccess={() => { setModalEditSimpleProduct(false); handleOnSuccess() }} btCancelAction={() => setModalEditSimpleProduct(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteSimpleProduct(simpleProductId)}
                message="Deseja realmente excluir esse produto?"
                itemName={simpleProductName}
            />

        </div>
    )
}

export default ListSimpleProductRow
